import { Injectable } from '@angular/core';
import { WIDGET } from '@main/enums';
import { WidgetSkeletonOptions } from './widget-skeleton.types';
import { widgetSkeletonDefaultOptions } from './widget-skeleton.config';

@Injectable({
    providedIn: 'root',
})
export class WidgetSkeletonService {
    private config = new Map<WIDGET, WidgetSkeletonOptions>();

    hasOptions(widget: WIDGET): boolean {
        return this.config.has(widget);
    }

    getOptions(widget: WIDGET): WidgetSkeletonOptions | undefined {
        return this.config.get(widget) ?? widgetSkeletonDefaultOptions[widget];
    }

    setOptions(widget: WIDGET, options: WidgetSkeletonOptions): void {
        this.config.set(widget, options);
    }

    removeOptions(widget: WIDGET): void {
        this.config.delete(widget);
    }

    clearOptions(): void {
        this.config.clear();
    }
}
